import React from 'react';
const SQL = () => {
  return (
    <iframe
      height="100%"
      width="100%"
      src="https://repl.it/@HibaMohammed/SQLite?lite=true"
      scrolling="no"
      frameborder="no"
      allowtransparency="true"
      allowfullscreen="true"
      sandbox="allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-modals"
    />
  );
};
export default SQL;
